import { TAuthTokens } from "../types";
import { api } from "@nbcom/api";

export const updateRefreshToken = async (): Promise<TAuthTokens | void> =>
  api.post<TAuthTokens>({
    url: `user/refresh_token`,
    credentials: `include`,
  });
